import { Badge, Drawer } from 'antd';
import MessageIcon from 'Components/common/assets/svgIcons/MessageIcon';
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import {
  leader, minWidthApp, retina, wMBold,
  maxWidth1170, maxTablet, primaryColor,
} from 'Utils/utilsStyle';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { actions as notesSlice } from 'Slice/NotesSlice';
import GlobalButton from 'Components/common/components/GlobalButton';
import LazyTooltip from 'Components/common/components/LazyTooltip';
import NotesIcon from '../../common/assets/svgIcons/NotesIcon';
import classNames from 'classnames';
import {
  selectNewNotes,
  selectPersonNotesAvaliable,
} from 'Selector/PersonProfileSelector';
import {
  Executive,
} from 'Types/PersonTypes';
import {
  getLocalStorageValue,
  isFreeUser,
  IsTablet,
  replaceURLWithoutReload,
  valueToObject,
} from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { RootState } from 'Store/InjectorsTypes';
import {
  selectAlertNotificationId,
} from 'Selector/NotesSelector';
import { GROUPDETAILS } from 'Utils/Constants';
import { selectCompanyNotesAvaliable, selectCompanyNewNotes } from 'Selector/CompaniesSelector';
import DrawerPeopleMoveReasonContent from './DrawerPeopleMoveReasonContent';

const Wrapper = styled.div`
  cursor: pointer;
  .triggers-bullet-tooltip{
    .ant-tooltip{
      z-index: 1;
      @media (max-width: ${maxTablet}) {
        display: none;
      }
    }  
  }
  .drawerAction{
    position: absolute;
    z-index: 1;
    right: 5px;
    top: 0px;
    cursor: pointer;
    @media all and (max-width: ${maxWidth1170}) {
      right: -2px;
      top: 0px;
    }
  }
  .messageIcon {
    &.removeIcon {
      display: none;
    }
    height: 26px;
    width: 26px;
    border-radius: 50%;
    background-color: ${primaryColor};
    position: relative;
    svg {
      position: absolute;
      left: 7px;
      top: 7px;
    }
    @media all and (max-width: ${maxWidth1170}) {
      height: 22px;
      width: 22px;
       svg {
        left: 7px;
        width: 8px;
        top: 5px;
      }
    }
  }
  .ant-badge-dot {
    width: 14px;
    height: 14px;
    background-color: ${leader};
    right: 9px;
    border: 2px solid #fff;
    top: 2px;
  }
  button{
    font-weight: ${wMBold};
    svg{
      margin-bottom: 2px;
      margin-right: 8px;
    }
  }
  .drawer-btn-action {
    &.notAvailable {
      .btn-notes-drawer {
        @media all and (max-width: ${minWidthApp}) {
          display: none;
        }
      }
    }
  }
  .notes-button-wrapper {
    @media all and (max-width: ${maxTablet}){
      width: unset !important;
    }
    .export_btn {
      margin-left: 8px;
      height: 32px;
      @media all and (max-width: ${maxTablet}){
        margin-left: 6px;
        padding: 0 !important;
        font-size: 0 !important;
      }
      svg {
        width: 15px;
        min-width: 15px;
        margin-right: 8px;
        @media all and (${retina}) {
          width: 14px;
          min-width: 14px;
        }
        @media all and (max-width: ${maxTablet}){
          margin-right: 0;
        } 
      }
    }
     @media all and (max-width: ${maxTablet}){ 
      width: 30px;
      .export_btn {
        width: 31px;
        height: 28px;
        padding: 0px 9px;
        svg {
          width: 14px;
          min-width: 14px;
        }
      }
    }   

  }
`;

const buildPersonYou = (): Executive => ({
  personName: getLocalStorageValue('fullname') || '',
  personImage: getLocalStorageValue('profilePic') || '',
  companyName: getLocalStorageValue('personCompany') || '',
  personDesignation: getLocalStorageValue('personDesignation') || '',
  location: '',
  companyId: 0,
  companyLogo: '',
  executiveType: '',
  headline: '',
  personId: 0,
  archeType: {
    personality: '',
    color: '',
    name: '',
    image: '',
  },
  personAdded: false,
  personalityTypes: [],
  feedid: 0,
});

type NotesTriggerButtonProps = {
  isPeopleNotes: boolean,
  notesAvailable: number | boolean,
  onClick: () => void,
};

const NotesTriggerButton = function NotesTriggerButton(props: NotesTriggerButtonProps) {
  const { isPeopleNotes, notesAvailable, onClick } = props;
  const isTab = IsTablet();
  const personNewNotes = useSelector(selectNewNotes);
  const companyNewNotes = useSelector(selectCompanyNewNotes);

  return (
    <LazyTooltip
      placement="bottom"
      getPopupContainer={(e: HTMLElement) => e}
      className="triggers-bullet-tooltip space-remove"
      color="#fff"
      title="Add a Note to Profile"
      arrow={false}
    >
      <Badge dot={isPeopleNotes ? !!personNewNotes : !!companyNewNotes}>
        <GlobalButton
          title={`${notesAvailable ? 'Notes' : 'Write a note'}`}
          textColor="#fff"
          bgColor={primaryColor}
          PaddingSm="8px 16px 8px"
          innerSpace="13px 20px 13px 20px"
          heightSm="35.6px"
          LeftSpace="12px"
          borderRadius="23px"
          IconLeft={isTab ? <span /> : <NotesIcon fllColor="#fff" disableHover />}
          onButtonClick={onClick}
          disabled={false}
          buttonClassName="btn-notes-drawer"
        />
      </Badge>
    </LazyTooltip>
  );
};

type Props = {
  personId?: number,
  companyId?: number,
  isPeopleNotes?: boolean,
  isCompanyNotes?: boolean,
  isPersonCard?: boolean,
  showNotes?: boolean,
  inBuyerGroup?: boolean,
  showDrawerIcon?: boolean,
  isBuyerGroupNotes?: boolean,
  onOpenChange?: (open: boolean) => void,
} & typeof defaultProps;

const defaultProps = {
  personId: 0,
  companyId: 0,
  isCompanyNotes: false,
  isPeopleNotes: false,
  showNotes: false,
  isPersonCard: false,
  inBuyerGroup: false,
  isBuyerGroupNotes: false,
  showDrawerIcon: false,
};

const DrawerPeopleMoveReason = function DrawerPeopleMoveReason(props: Props) {
  const {
    personId,
    isPeopleNotes,
    showNotes,
    companyId,
    isCompanyNotes,
    isPersonCard,
    inBuyerGroup,
    isBuyerGroupNotes,
    showDrawerIcon,
    onOpenChange,
  } = props;
  const dispatch = useDispatch();
  const store = useStore();
  const [toggle, setToggle] = useState(false);
  const hasOpenedDrawer = useRef(false);
  if (toggle) hasOpenedDrawer.current = true;
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');
  const isNotes = searchParams.get('isNotes') === 'true';
  const isNoteId = searchParams.get('noteId');
  const groupIdParsed = groupId ? parseInt(groupId, 10) : 0;

  const [personYou] = useState<Executive>(buildPersonYou);
  const [isGroupDetail] = useState(window.location.pathname.includes(GROUPDETAILS));

  const notesAvailable = useSelector(
    isPeopleNotes ? selectPersonNotesAvaliable : selectCompanyNotesAvaliable,
  );

  const alertsNotificationId = useSelector(selectAlertNotificationId);

  useEffect(() => {
    onOpenChange?.(toggle);
  }, [toggle, onOpenChange]);


  useEffect(() => {
    onOpenChange?.(toggle);
  }, [toggle, onOpenChange]);

  const clickToggle = () => {
    if (toggle && !isNoteId) {
      dispatch(notesSlice.setAlertsNotificationId(0));
    }
    if (personYou) {
      setToggle(!toggle);
      dispatch(notesSlice.resetPersonNotes());
    }
    if (!toggle && isNoteId && isNoteId > '0') {
      dispatch(notesSlice.setAlertsNotificationId(0));
    }
    if (isPeopleNotes) {
      dispatch(certificationActions.certificationAction({
        type: 'person_note_write',
        source: 'person',
        data: selectData(store.getState() as RootState),
      }));
    }
  };

  useEffect(() => {
    const node = document.querySelector('body');
    return toggle ? node?.classList.add('body-drawer-toggle-account-plan') : node?.classList.remove('body-drawer-toggle-account-plan');
  }, [toggle]);

  useEffect(() => {
    if (isNotes && personYou && (alertsNotificationId > 0 || (isNoteId !== null && isNoteId > '0'))) {
      setToggle(true);
      replaceURLWithoutReload('isNotes', 'false');
      if (isNoteId !== null && isNoteId > '0') {
        dispatch(notesSlice.setAlertsNotificationId(parseInt(isNoteId, 10)));
      }
    }
  }, [isNotes, personYou, alertsNotificationId]);

  useEffect(() => {
    setToggle(false);
  }, [personId, companyId]);

  const handleFlurry = () => {
    if (!toggle && isCompanyNotes) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('companyNotes_open_clicked', 0, {
          companyId,
        }),
      ));
    }
  };

  return (
    <Wrapper>
      {!isFreeUser() && !isBuyerGroupNotes
        && (
          <span
            onClick={clickToggle}
            onKeyPress={clickToggle}
            tabIndex={0}
            role="button"
            aria-label="drawer-open"
            className={classNames('drawer-btn-action', {
              drawerAction: !isPeopleNotes && !isCompanyNotes,
              notAvailable: !notesAvailable,
            })}
          >
            {!showNotes ? (
              <NotesTriggerButton
                isPeopleNotes={isPeopleNotes}
                notesAvailable={notesAvailable}
                onClick={() => {
                  handleFlurry();
                  clickToggle();
                }}
              />
            ) : (
              <LazyTooltip
                placement="top"
                className="triggers-bullet-tooltip smartHistoryTip"
                color="#fff"
                title="View notes added"
                arrow={false}
              >
                <div className="messageIcon">
                  <MessageIcon color="#fff" />
                </div>
              </LazyTooltip>
            )}
          </span>
        )}
      {isBuyerGroupNotes && (
        <div className="notes-button-wrapper">
          <GlobalButton
            title="Notes"
            textColor="#7E7E7E"
            bgColor="#fff"
            outlineColor="#DADADA"
            innerSpace="6px 15px 6px 15px"
            LeftSpace="7px"
            IconLeft={<NotesIcon fllColor="#7E7E7E" disableHover />}
            buttonClassName="share-button mr-24 export_btn"
            rightSeparatorClassName="right-separator-class"
            borderWidth="1px"
            onButtonClick={clickToggle}
          />
        </div>
      )}

      {hasOpenedDrawer.current && (
        <Drawer
          rootClassName="drawer-alerts reason-drawer"
          placement="right"
          onClose={clickToggle}
          open={toggle}
          destroyOnClose
          width={530}
        >
          <DrawerPeopleMoveReasonContent
            personId={personId}
            companyId={companyId}
            isPeopleNotes={isPeopleNotes}
            isCompanyNotes={isCompanyNotes}
            isPersonCard={isPersonCard}
            showNotes={showNotes}
            inBuyerGroup={inBuyerGroup}
            isBuyerGroupNotes={isBuyerGroupNotes}
            isGroupDetail={isGroupDetail}
            isNotes={isNotes}
            groupIdParsed={groupIdParsed}
            notesAvailable={notesAvailable}
            alertsNotificationId={alertsNotificationId}
            personYou={personYou}
            onClose={clickToggle}
          />
        </Drawer>
      )}
    </Wrapper>

  );
};

DrawerPeopleMoveReason.defaultProps = defaultProps;
export default React.memo(DrawerPeopleMoveReason);
